module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-header",
    class: {
      'kiwi-header--showall': _vm.buffer_settings_open,
    },
    on: {
      "click": _vm.onHeaderClick
    }
  }, [(_vm.isChannel()) ? [_c('div', {
    staticClass: "kiwi-header-options"
  }, [_c('a', {
    staticClass: "u-button u-button-secondary",
    on: {
      "click": _vm.closeCurrentBuffer
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))])]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-header-name"
  }, [_vm._v(_vm._s(_vm.buffer.name))]), _vm._v(" "), (_vm.isJoined) ? _c('div', {
    staticClass: "kiwi-header-topic"
  }) : _vm._e(), _vm._v(" "), (!_vm.isJoined && _vm.isConnected) ? _c('div', {
    staticClass: "kiwi-header-notjoined"
  }, [_c('a', {
    staticClass: "u-link",
    on: {
      "click": _vm.joinCurrentBuffer
    }
  }, [_vm._v(_vm._s(_vm.$t('container_join')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kiwi-header-tools"
  }, _vm._l((_vm.pluginUiChannelElements), function(el) {
    return _c('div', {
      directives: [{
        name: "rawElement",
        rawName: "v-rawElement",
        value: (el),
        expression: "el"
      }],
      staticClass: "kiwi-header-tool"
    })
  }))] : (_vm.isServer()) ? [(_vm.buffer.getNetwork().state === 'disconnected') ? _c('div', {
    staticClass: "kiwi-header-server-connection"
  }, [_c('a', {
    staticClass: "u-button u-button-primary",
    on: {
      "click": function($event) {
        _vm.buffer.getNetwork().ircClient.connect()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('connect')))])]) : (_vm.buffer.getNetwork().state === 'connecting') ? _c('div', {
    staticClass: "kiwi-header-server-connection"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('connecting')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kiwi-header-name"
  }, [_vm._v(_vm._s(_vm.buffer.getNetwork().name))])] : (_vm.isQuery()) ? [_c('div', {
    staticClass: "kiwi-header-options"
  }, [_c('a', {
    staticClass: "u-button u-button-secondary",
    on: {
      "click": _vm.closeCurrentBuffer
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))])]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-header-name"
  }, [_vm._v(_vm._s(_vm.buffer.name))]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-header-tools"
  }, _vm._l((_vm.pluginUiQueryElements), function(el) {
    return _c('div', {
      directives: [{
        name: "rawElement",
        rawName: "v-rawElement",
        value: (el),
        expression: "el"
      }],
      staticClass: "kiwi-header-tool"
    })
  }))] : (_vm.isSpecial()) ? [_c('div', {
    staticClass: "kiwi-header-options"
  }, [_c('a', {
    staticClass: "u-button u-button-secondary",
    on: {
      "click": _vm.closeCurrentBuffer
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))])]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-header-name"
  }, [_vm._v(_vm._s(_vm.buffer.name))])] : _vm._e(), _vm._v(" "), (_vm.buffer_settings_open) ? _c('div', {
    staticClass: "kiwi-header-buffersettings",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('tabbed-view', [_c('tabbed-tab', {
    attrs: {
      "header": _vm.$t('settings'),
      "focus": true
    }
  }, [_c('channel-info', {
    attrs: {
      "buffer": _vm.buffer
    }
  })], 1), _vm._v(" "), _c('tabbed-tab', {
    attrs: {
      "header": _vm.$t('banned')
    }
  }, [_c('channel-banlist', {
    attrs: {
      "buffer": _vm.buffer
    }
  })], 1), _vm._v(" "), _c('tabbed-tab', {
    attrs: {
      "header": _vm.$t('notifications')
    }
  }, [_c('buffer-settings', {
    attrs: {
      "buffer": _vm.buffer
    }
  })], 1)], 1), _vm._v(" "), _c('a', {
    staticClass: "u-button u-button-secondary kiwi-header-close-buffersettings",
    on: {
      "click": function($event) {
        _vm.buffer_settings_open = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ac529f3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContainerHeader.vue
// module id = 475
// module chunks = 2